module.exports = "mutation UpdateAttribute($attribute:UpdateAttributeInput!){updateAttribute(attribute:$attribute){success}}"